export default "__VITE_ASSET__CxTMiOuN__"